/**
 * List of options for the Printer types field
 *
 * @namespace tmrPrinterTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrPrinterTypes',
  {
    ZebraCardPrinterDto: 'Zebra Card Printer',
    ZebraPrinterDto: 'Zebra',
    EpsonPrinterDto: 'Epson',
    GenericNoRfidPrinterDto: 'GenericNoRfid',
    AveryPrinterDto: 'Avery',
  },
]
